import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { Box, TextField, Grid, Button } from '@mui/material';
import { makeApiRequest } from '../../Shared/Api';

const EditCustomer = ({ open, onClose, onSubmit, selectedCustomer }) => {
	const [formData, setFormData] = useState({
		name: selectedCustomer?.name || '',
		phone: selectedCustomer?.phone || '',
		email: selectedCustomer?.email || '',
		invoicing_email: selectedCustomer?.invoicing_email || '',
	});

	useEffect(() => {
		if (selectedCustomer) {
			setFormData(selectedCustomer);
		} else {
			setFormData({ name: '', phone: '', email: '', invoicing_email: '' });
		}
	}, [selectedCustomer, open]);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleSubmit = async () => {
		try {
			const url = selectedCustomer
				? `/customers/${selectedCustomer.id}/`
				: '/customers/';
			const method = selectedCustomer ? 'PUT' : 'POST';
			const payload = {
				...formData,
				invoicing_email: formData.invoicing_email.trim() || null,
			};
			const response = await makeApiRequest(method, url, payload);
			if (onSubmit) {
				onSubmit(response);
			}
			onClose();
		} catch (error) {
			console.error('Failed to save customer:', error);
		}
	};

	const SubmitButton = () => (
		<Button variant="contained" onClick={handleSubmit}>
			{selectedCustomer ? 'Save Customer' : 'Create Customer'}
		</Button>
	);

	return (
		<Modal
			open={open}
			onClose={onClose}
			useActionButtons
			actionButtons={<SubmitButton />}
			modalTitle={selectedCustomer ? 'Edit Customer' : 'Create Customer'}
			maxWidth="sm"
		>
			<Box sx={{ mt: 2 }}>
				<Grid container spacing={2}>
					<TextField
						label="Name"
						name="name"
						value={formData.name}
						onChange={handleInputChange}
						fullWidth
						required
					/>
					<TextField
						label="Email"
						name="email"
						type="email"
						value={formData.email}
						onChange={handleInputChange}
						fullWidth
						required
					/>
					<TextField
						label="Invoicing Email"
						name="invoicing_email"
						type="email"
						value={formData.invoicing_email}
						onChange={handleInputChange}
						fullWidth
						helperText="Optional. CC'd on bids and invoices when different from email."
					/>
					<TextField
						label="Phone"
						name="phone"
						value={formData.phone}
						onChange={handleInputChange}
						fullWidth
						required
					/>
				</Grid>
			</Box>
		</Modal>
	);
};

export default EditCustomer;
